import * as yup from 'yup';
import { FORM_ERROR_MESSAGE } from 'yupHelper';
import { validateFiles } from './helpers';

export const IMAGE_MAX_FILE_SIZE_MB = 10;
export const IMAGE_MAX_FILE_SIZE_BYTES = IMAGE_MAX_FILE_SIZE_MB * 1024 * 1024;
export const IMAGE_MAX_WIDTH = 1920;
export const IMAGE_MAX_HEIGHT = 1080;

export const VIDEO_MAX_FILE_SIZE_GB = 5;
export const VIDEO_MAX_FILE_SIZE_BYTES =
  VIDEO_MAX_FILE_SIZE_GB * 1024 * 1024 * 1024;

export const getValidationSchema = (
  maxFiles: number,
  acceptedExtensions: string,
) =>
  yup.object().shape({
    files: yup
      .mixed<File[]>()
      .test(
        'required',
        FORM_ERROR_MESSAGE.REQUIRED,
        (files: File[] | undefined) => {
          if (!files || files.length === 0) {
            return false;
          }
          return files.length > 0;
        },
      )
      .test('files-validation', '', async function (files: File[] | undefined) {
        if (!files || files.length === 0) {
          return true;
        }

        const { errors } = await validateFiles({
          files: [],
          newFiles: files,
          acceptedExtensions,
          maxFiles,
        });

        return errors.length === 0 || this.createError({ message: errors[0] });
      }),
  });
